import { SwaggerException } from '../sdk/sdk';
import { commissionErrorMessage } from './commission-error-message';

// R3b — 409 and 404 carry two different facts and the administrator has to be able to tell them
// apart: someone else approved the row first, or the row is gone. Collapsing them onto one string
// is exactly what the requirement exists to prevent.
//
// Neither can be left to commissionErrorMessage. It only reads a 409's body, and the endpoint's
// reason arrives empty often enough that the 409 would fall through to its generic string — which
// reads identically to every other failure, so the two facts would silently merge again. The
// server's reason is deliberately not surfaced: both messages also have to say the list was
// refetched, which is a client-side fact the endpoint cannot know.
export const PPJ_EXCEPTION_APPROVED_ELSEWHERE_MESSAGE =
  'Someone else approved this exception first, so it is now locked. The list has been refreshed.';
export const PPJ_EXCEPTION_GONE_MESSAGE =
  'This exception no longer exists. The list has been refreshed.';

export function ppjExceptionActionMessage(err: unknown): string {
  if (!SwaggerException.isSwaggerException(err)) {
    return commissionErrorMessage(err);
  }
  if (err.status === 409) {
    return PPJ_EXCEPTION_APPROVED_ELSEWHERE_MESSAGE;
  }
  if (err.status === 404) {
    return PPJ_EXCEPTION_GONE_MESSAGE;
  }
  return commissionErrorMessage(err);
}
